import { render, staticRenderFns } from "./ModalShowRegistry.vue?vue&type=template&id=cfcd8f2c&"
import script from "./ModalShowRegistry.vue?vue&type=script&lang=js&"
export * from "./ModalShowRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports